import { supabase } from '@/integrations/supabase/client';
import type { Json } from '@/integrations/supabase/types';

/**
 * Standalone audit log function — does not require React context.
 * Uses a SECURITY DEFINER RPC to prevent direct audit log injection.
 */
export async function logAuditAction(
  userId: string,
  action: string,
  description: string,
  metadata?: Json,
  organizationId?: string | null
) {
  try {
    await supabase.rpc('create_audit_log', {
      _action: action,
      _description: description,
      _metadata: (metadata ?? null) as any,
      _organization_id: organizationId ?? null,
    });
  } catch (e) {
    // Fire-and-forget: never block the main flow
    console.error('[audit-log] failed to write:', e);
  }
}
